import { __extends } from "tslib";
import React, { Component } from 'react';
import { FaPen } from 'react-icons/fa';
import { cloneDeep } from 'lodash';
import { checkMonthGaps, positionDrops, formatDate, addMinmumMonths } from '../utils/deliveryWindowsHelper';
import { ContextMenu, Icon, Menu, MenuItem } from "@blueprintjs/core";
import { TweenLite } from "gsap";
var DeliveryWindows = /** @class */ (function (_super) {
    __extends(DeliveryWindows, _super);
    function DeliveryWindows(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            months: [],
            data: {},
            drops: {},
            deliveryWindows: [],
            showLeftArrow: false,
            showRightArrow: true,
            showArrows: false,
            arrowsInitialized: false,
            monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        };
        _this.container = React.createRef();
        _this.handleResize = function () {
            if (_this.container.current) {
                if (+_this.container.current.scrollWidth > +_this.container.current.clientWidth && !_this.state.showArrows) {
                    _this.setState({ showArrows: true });
                }
                else {
                    if (_this.state.showArrows &&
                        +_this.container.current.scrollWidth === +_this.container.current.clientWidth) {
                        _this.setState({ showArrows: false });
                    }
                }
            }
        };
        _this.onClickFilterGroup = function (drop) {
            _this.props.onClickFilterGroup('deliverywindows', {
                value: drop.deliveryCode
            });
        };
        _this.showContextMenu = function (e, drop) {
            // must prevent default to cancel parent's context menu
            e.preventDefault();
            // invoke static API, getting coordinates from mouse event
            ContextMenu.show(React.createElement(Menu, null,
                React.createElement(MenuItem, { icon: "list-detail-view", text: "View items", onClick: function (e) { return _this.onClickFilterGroup(drop); } }),
                !_this.props.hideEditLink && !drop.shipped && React.createElement(MenuItem, { className: "hide-on-mobile", icon: "calendar", text: "Change shipping date", onClick: function () { return _this.onClickDrop(drop); } })), { left: e.clientX, top: e.clientY }, function () { return _this.setState({ isContextMenuOpen: false }); });
            // indicate that context menu is open so we can add a CSS class to this element
            _this.setState({ isContextMenuOpen: true });
        };
        _this.scrollLeftRight = function (direction) {
            if (_this.container.current) {
                if (direction === 'left') {
                    _this.container.current.scrollLeft -= _this.container.current.scrollWidth;
                }
                if (direction === 'right') {
                    _this.container.current.scrollLeft += _this.container.current.scrollWidth;
                }
            }
        };
        _this.handleScroll = function (e) {
            var scrollLeft = e.target.scrollLeft;
            if (scrollLeft > 0) {
                _this.setState({ showLeftArrow: true });
            }
            if (scrollLeft === 0) {
                _this.setState({ showLeftArrow: false });
            }
        };
        _this.box = null;
        _this.t = null;
        _this.myTween = null;
        return _this;
    }
    DeliveryWindows.prototype.componentDidMount = function () {
        if (this.props.deliveryWindows) {
            this.setupMonths(this.props.deliveryWindows);
        }
        if (this.container.current) {
            if (+this.container.current.scrollWidth > +this.container.current.clientWidth) {
                this.setState({ showArrows: true, arrowsInitialized: true });
            }
        }
        window.addEventListener('resize', this.handleResize);
    };
    DeliveryWindows.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.deliveryWindows !== this.props.deliveryWindows) {
            this.setupMonths(this.props.deliveryWindows);
        }
        if (!this.state.arrowsInitialized && this.container.current) {
            if (+this.container.current.scrollWidth > +this.container.current.clientWidth) {
                this.t = TweenLite.to(this.box, 1, { duration: 1, opacity: 1, y: 0, stagger: 0.25 });
                this.setState({ showArrows: true, arrowsInitialized: true });
            }
        }
    };
    DeliveryWindows.prototype.setupMonths = function (deliveryWindows) {
        var _this = this;
        deliveryWindows.sort(function compare(a, b) {
            var dateA = new Date(a.shippingDate);
            var dateB = new Date(b.shippingDate);
            return dateA - dateB;
        });
        // let months = this.state.months;
        var months = [];
        var data = {};
        for (var i in deliveryWindows) {
            var delivery = deliveryWindows[i];
            var date = new Date(delivery.shippingDate);
            var year = date.getFullYear();
            var month = this.state.monthNames[date.getMonth()];
            var label = month + ' ' + year;
            if (months.indexOf(label) === -1) {
                months.push(label);
                // @ts-ignore
                data[label] = [delivery];
            }
        }
        ;
        var newMonths = checkMonthGaps(months, data, this.state.monthNames, deliveryWindows);
        var newMonthsWithMinimumMonths = addMinmumMonths(cloneDeep(newMonths), data, this.state.monthNames, deliveryWindows);
        this.setState({
            months: newMonthsWithMinimumMonths,
            data: data,
        }, function () {
            _this.setupDrops();
        });
    };
    DeliveryWindows.prototype.setupDrops = function () {
        var drops = {};
        for (var i in this.props.deliveryWindows) {
            var delivery = this.props.deliveryWindows[i];
            var date = new Date(delivery.shippingDate);
            var year = date.getFullYear();
            var month = this.state.monthNames[date.getMonth()];
            var label = month + ' ' + year;
            // @ts-ignore
            if (!drops[label]) {
                // @ts-ignore
                drops[label] = [];
            }
            // @ts-ignore
            drops[label].push({
                date: date,
                shippingDate: new Date(delivery.shippingDate),
                shippingFrom: new Date(delivery.shippingFrom),
                shippingdateVisual: formatDate(new Date(delivery.shippingDate)),
                deliveryCode: delivery.deliveryCode,
                delivreryShortdescription: delivery.delivreryShortdescription,
                position: 0,
                shipped: delivery.shipped,
            });
        }
        drops = positionDrops(drops, this.state.months);
        this.setState({ drops: drops });
    };
    DeliveryWindows.prototype.onClickDrop = function (drop) {
        this.props.onClickDrop(drop);
    };
    DeliveryWindows.prototype.renderDrops = function (month) {
        var _this = this;
        // @ts-ignore
        if (!this.state.drops[month]) {
            return null;
        }
        // @ts-ignore
        var dropsForMonth = this.state.drops[month];
        return Object.keys(dropsForMonth).map(function (key, $index) {
            var drops = dropsForMonth[key];
            if (!drops.length) {
                return null;
            }
            return React.createElement("div", { className: "delivery-windows__drop clickable", style: { gridRowStart: $index - 1 }, key: $index }, drops.length &&
                drops.map(function (drop, index) {
                    return React.createElement("div", { className: "delivery-windows__drop__item", onClick: function (e) { return _this.showContextMenu(e, drop); }, style: { gridRow: drop.position }, key: "".concat(drop.deliveryCode, "/").concat(index) },
                        React.createElement("p", { className: "delivery-windows__drop-header" }, drop.deliveryCode === 'specdate' ? 'Shipping Date' : drop.deliveryCode),
                        React.createElement("p", { className: "delivery-windows__drop-shippingdate" }, drop.shippingdateVisual),
                        !_this.props.hideEditLink &&
                            React.createElement("p", { className: "delivery-windows__change-link" },
                                React.createElement("span", null, !drop.shipped ? 'Change shipping date' : 'View items'),
                                !drop.shipped && React.createElement("span", { className: "icon" },
                                    React.createElement(FaPen, null))),
                        drop.shipped &&
                            React.createElement("span", { className: "item-blocked" }, "Shipped"));
                }));
        });
    };
    DeliveryWindows.prototype.renderMonths = function () {
        var _this = this;
        return this.state.months.map(function (month, $index) {
            return (React.createElement("div", { className: "delivery-windows__month", key: $index },
                React.createElement("div", { className: "delivery-windows__month-header" },
                    React.createElement("h2", { className: "delivery-windows__month-name" }, month)),
                React.createElement("div", { ref: function (e) { return _this.box = e; }, className: "delivery-windows__month-days", style: { gridTemplateRows: 'repeat(5, 1fr)' } }, _this.renderDrops(month))));
        });
    };
    DeliveryWindows.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "delivery-windows", ref: this.container, onScroll: this.handleScroll }, this.renderMonths()),
            this.state.showLeftArrow && this.state.showArrows &&
                React.createElement("div", { className: "delivery-windows__scroll-arrow left", onClick: function () { return _this.scrollLeftRight('left'); } },
                    React.createElement(Icon, { icon: "circle-arrow-left", iconSize: 25 })),
            this.state.showRightArrow && this.state.showArrows &&
                React.createElement("div", { className: "delivery-windows__scroll-arrow right", onClick: function () { return _this.scrollLeftRight('right'); } },
                    React.createElement(Icon, { icon: "circle-arrow-right", iconSize: 25 }))));
    };
    return DeliveryWindows;
}(Component));
export { DeliveryWindows };
export default DeliveryWindows;
//# sourceMappingURL=DeliveryWindows.js.map